import React, { useState } from 'react';
import { Box, Snackbar, Alert, ToggleButton, ToggleButtonGroup } from '@mui/material';
import ChecklistManagement from '../components/ChecklistManagement';
import PromptLibrary from '../components/PromptLibrary';
import { ListAlt as ListAltIcon, LibraryBooks as LibraryBooksIcon } from '@mui/icons-material';

const BlogChecklist: React.FC = () => {
  const [view, setView] = useState<'checklist' | 'prompts'>('checklist');
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: 'success' | 'error';
  }>({ open: false, message: '', severity: 'success' });

  const showSnackbar = (message: string, severity: 'success' | 'error') => {
    setSnackbar({ open: true, message, severity });
  };

  const handleViewChange = (
    _event: React.MouseEvent<HTMLElement>,
    newView: 'checklist' | 'prompts'
  ) => {
    if (newView !== null) {
      setView(newView);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* View Toggle */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 3 }}>
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={handleViewChange}
          aria-label='view switcher'
          sx={{
            bgcolor: 'rgba(255, 255, 255, 0.05)',
            borderRadius: 2,
            '& .MuiToggleButton-root': {
              color: '#8f90a6',
              textTransform: 'none',
              px: 3,
              py: 1,
              border: '1px solid rgba(255, 255, 255, 0.1)',
              '&.Mui-selected': {
                bgcolor: '#6871d1',
                color: '#fff',
                '&:hover': {
                  bgcolor: '#5a63bb',
                },
              },
            },
          }}
        >
          <ToggleButton value='checklist'>
            <ListAltIcon sx={{ mr: 1, fontSize: 20 }} />
            Blog Checklist
          </ToggleButton>
          <ToggleButton value='prompts'>
            <LibraryBooksIcon sx={{ mr: 1, fontSize: 20 }} />
            Prompt Library
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {/* Content */}
      <Box>
        {view === 'checklist' ? (
          <ChecklistManagement category='Blog' onShowSnackbar={showSnackbar} />
        ) : (
          <PromptLibrary onShowSnackbar={showSnackbar} />
        )}
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default BlogChecklist;
